import { FC, useState } from 'react';
import { useAuth } from 'src/hooks/useAuth';
import { API } from 'src/config/config';
import toast from 'react-hot-toast';
import { CreatePerkForm } from '../../content/applications/Perks/CreatePerkForm';


interface ICreatePerksModal {
  open: boolean;
  onClose: () => void;
  refreshPerks: () => void;
}

const CreatePerksModal: FC<ICreatePerksModal> = ({ open, onClose, refreshPerks }) => {
  const { enhancedFetch } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (formData) => {
    setIsLoading(true);
    enhancedFetch(`${API.HOST}/api/v1/perks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(() => {
        toast.success('Perk created successfully!');
        refreshPerks();
        onClose();
      })
      .catch((error) => {
        console.error('Error creating perk:', error.message);
        toast.error('Failed to create perk');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return CreatePerkForm({
    onSubmit: handleSubmit,
    data: {
      title: '',
      description: ''
    },
    openModal: open,
    onClose: onClose,
    title: 'Create New Perk',
    isLoading: isLoading,
    fullWidth: true,
    maxWidth: 'sm'
  });
};

export default CreatePerksModal;
